import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

interface IProps {
    children: React.ReactNode;
}

export const ContextActionBar = ({ children }: IProps) => (
    <>
        <Box
            sx={[
                { position: 'fixed' },
                (theme) => ({
                    top: `calc(${theme.mixins.toolbar.height as number}px + var(--top-offset, 0px))`,
                    left: 0,
                    right: 0,
                    zIndex: theme.zIndex.appBar - 1,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: theme.vars.palette.background.default,
                    minHeight: theme.mixins.contextActionBar.height,
                    display: 'flex',
                    alignItems: 'center',
                }),
            ]}
        >
            <Container
                maxWidth="md"
                sx={{
                    py: 1,
                    overflowX: 'auto',
                    display: 'flex',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        minWidth: 0,
                        width: '100%',
                        flex: 1,
                    }}
                >
                    {children}
                </Box>
            </Container>
        </Box>
        {/* Spacer to account for the context action bar height */}
        <Box
            sx={(theme) => ({ height: theme.mixins.contextActionBar.height })}
        />
    </>
);
